module.exports = __webpack_public_path__ + "img/2.07bb8c18.jpg";